import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from '../../api'
import { StatusCodes } from '../../http-status-codes'
import { UnexpectedApiResponseError } from 'src/Libs/errors'
import { AmazonGiftCardUploadingResultDto, AmazonCodeStatsDto, AmazonCodeByIdDto } from './dto/amazon-codes.dto'
import { handleFetchError } from 'src/Libs/api/utils'

/**
 * Upload amazon card to add referal codes to pool
 */
export const uploadAmazonCard = async (payload: FormData, authFetch: AuthFetchWithResponse): Promise<ApiResult<AmazonGiftCardUploadingResultDto>> => {
  const response = await authFetch<AmazonGiftCardUploadingResultDto>({
    path: `users/amazon-codes`,
    method: 'POST',
    payload,
  })

  if (response.status === StatusCodes.CREATED) {
    return new ApiResult<AmazonGiftCardUploadingResultDto>(response.data, false)
  }

  return new ApiResult<AmazonGiftCardUploadingResultDto>(null, true)
}

/**
 * Get the total number of available amazon codes
 */
export const getAvailabeAmazonCodeStats = async (authFetch: AuthFetchWithResponse): Promise<ApiResult<AmazonCodeStatsDto>> => {
  const response = await authFetch<AmazonCodeStatsDto>({
    path: `users/amazon-codes/stats`,
    method: 'GET',
    payload: {
      isUsed: false,
    },
  })

  if (response.status === StatusCodes.OK) {
    return new ApiResult<AmazonCodeStatsDto>(response.data, false)
  }

  if (response.status === StatusCodes.NO_CONTENT) return new ApiResult<AmazonCodeStatsDto>(null, true)
  throw new UnexpectedApiResponseError(response.status)
}

/**
 * Get the amazon code data by amazon code uuid
 */
export const getAmazonCodeDataById = async (id: string, authFetch: AuthFetchWithResponse): Promise<ApiResult<AmazonCodeByIdDto>> => {
  try {
    const response = await authFetch<AmazonCodeByIdDto>({
      path: `users/amazon-codes/${id}`,
      method: 'GET',
    })

    return new ApiResult<AmazonCodeByIdDto>(response.data, false)
  } catch (err) {
    return handleFetchError<AmazonCodeByIdDto>(err)
  }
}
